import {Button, Container, Row} from "react-bootstrap";
import React from 'react';
import {ButtonGroup} from "reactstrap";
import {FaTrash, FaDownload, FaUpload, FaCircleONotch} from "react-icons/lib/fa";
import DocumentService from "../../services/DocumentService";

//The API service is a self-contained static provider to talk to the certblock api
const documentService = new DocumentService();

export class DocumentEditField extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			documentExists: props.documentExists,
			documentExistsGlobally: props.documentExistsGlobally,
			orderNumber: props.orderNumber,
			documentProfileId: props.documentProfileId,
			deliveryNoteNumber: props.deliveryNoteNumber,
			orderPosition: props.orderPosition,
			serialNumber: props.serialNumber,
			downloadActive: false,
			uploadActive: false,
			registerPendingUploadEventHandler: props.registerPendingUploadEventHandler,
			registerPendingDeleteEventHandler: props.registerPendingDeleteEventHandler,
			pendingUpload: false,
			pendingDelete: false,
			enableDownload: props.enableDownload,
			enableUpload: props.enableUpload
		}
		this.uploadFileInput = React.createRef();
	}

	async triggerUploadHandler(files) {
		console.log("triggered upload for", this.state.serialNumber, this.state.documentProfileId, files);
		this.setState({
			uploadActive: true
		});
		await documentService.uploadDocument({
			orderNumber: this.state.orderNumber,
			deliveryNoteNumber: this.state.deliveryNoteNumber,
			orderPosition: this.state.orderPosition,
			documentProfileId: this.state.documentProfileId,
			serialNumber: this.state.serialNumber,
			files
		});
		this.setState({
			uploadActive: false,
			pendingUpload: false
		});
	}

	async triggerDeleteHandler() {
		console.log("triggered delete for", this.state.serialNumber, this.state.documentProfileId);
	}

	registerUpload(files) {
		let componentIdentifier = `${this.state.serialNumber}-${this.state.documentProfileId}`;
		console.log("cdscdsdsc", this.state.registerPendingUploadEventHandler);
		if (this.state.registerPendingUploadEventHandler) {
			this.state.registerPendingUploadEventHandler({key: componentIdentifier, handler: async () => this.triggerUploadHandler(files)});
		}
		this.setState({
			pendingUpload: true
		})
	}

	registerDelete() {
		let componentIdentifier = `${this.state.serialNumber}-${this.state.documentProfileId}`;
		if (this.state.registerPendingDeleteEventHandler) {
			this.state.registerPendingDeleteEventHandler({key: componentIdentifier, handler: async () => this.triggerDeleteHandler()});
		}
		this.setState({
			pendingDelete: true
		})
	}

	triggerFileSelect(event) {
		event.stopPropagation();
		event.preventDefault();
		let files = event.target.files;
		this.registerUpload(files);
	}

	async downloadFile({documentExistsGlobally, documentExists, orderNumber, deliveryNoteNumber, orderPosition, documentProfileId, serialNumber}) {
		this.setState({downloadActive: true});
		try {
			if (documentExists) {
				await documentService.downloadDocument({orderNumber, deliveryNoteNumber, orderPosition, documentProfileId, serialNumber});
			} else if (documentExistsGlobally) {
				await documentService.downloadDocument({orderNumber, deliveryNoteNumber, orderPosition, documentProfileId});
			}
		} catch (e) {
			//TODO: error handling
		}
		this.setState({downloadActive: false});
	}

	render() {
		return (
			<Container>
				<input type="file"
					   style={{display: "none"}}
					   ref={(ref) => this.uploadFileInput = ref}
					   onChange={this.triggerFileSelect.bind(this)}
					   accept=".application/pdf,.pdf"
					   multiple
				/>
				{this.state.counter}
				<Row>
					<ButtonGroup className={"col-12 p-0"} size={"sm"}>
						{this.props.enableDownload &&
							<Button className={"flex-grow-1"}
									variant={this.state.documentExists || this.state.documentExistsGlobally ? "outline-success" : "outline-secondary"}
									disabled={!(this.state.documentExists || this.state.documentExistsGlobally)}
									onClick={() => this.downloadFile(this.state)}>
								<FaDownload/>&nbsp;&nbsp;Download
								{this.state.downloadActive ? (<FaCircleONotch className={"spin"}/>) : ""}
							</Button>
						}
						{this.props.enableUpload &&
							<Button className={"flex-grow-1"}
									variant={this.state.pendingUpload ? "primary" : "outline-primary"}
									onClick={() => this.uploadFileInput.click()}>
								<FaUpload/>&nbsp;&nbsp;Upload&nbsp;&nbsp;
								{this.state.uploadActive ? (<FaCircleONotch className={"spin"}/>) : ""}
							</Button>
						}
						{/*<Button variant={this.state.documentExists ? this.state.pendingDelete ? "danger" : "outline-danger" : "outline-secondary"}*/}
						{/*		disabled={!this.state.documentExists}*/}
						{/*		onClick={() => this.registerDelete()}>*/}
						{/*	<FaTrash/>*/}
						{/*</Button>*/}
					</ButtonGroup>
				</Row>
			</Container>
		);
	}

}